import { ref, onBeforeMount } from 'vue'

const introShown = ref(false)
const preIntroShown = ref(false)

export default function useIntroShown() {
  const setIntroComplete = () => {
    introShown.value = true
    window.sessionStorage.setItem('introShown', 'true')
  }

  const setPreIntroComplete = () => {
    preIntroShown.value = true
    window.sessionStorage.setItem('preIntroShown', 'true')
  }

  onBeforeMount(() => {
    introShown.value = window.sessionStorage.getItem('introShown') === 'true'
    preIntroShown.value =
      window.sessionStorage.getItem('preIntroShown') === 'true'
  })

  return {
    introShown,
    preIntroShown,
    setPreIntroComplete,
    setIntroComplete,
  }
}
